import { Container, Grid } from '@mui/material';
import React, { useState } from "react";
import { isAdmin } from '../../services/auth';
import LoadingIndicator from "../../components/loadingIndicator";
import PageHeaderButton from '../../components/pageHeaderButton';
import ReportsTable from "./reportsTable";
import { Navigate } from "react-router-dom";

const Reports = props => {
    const [loadingData, setLoadingData] = useState(false);

    if (!isAdmin()) return <Navigate to="/dashboard" />;

    return (
        <Container maxWidth="xg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <PageHeaderButton
                        title="Relatórios"
                        path="/reports"
                        canCreate={isAdmin()}></PageHeaderButton>
                </Grid>
                <Grid sx={{ display: loadingData ? "flex" : "none", justifyContent: "center" }} item xs={12}>
                    <LoadingIndicator />
                </Grid>
                <Grid display={loadingData && "none"} item xs={12}>
                    <ReportsTable
                        setLoadingData={setLoadingData}
                    />
                </Grid>
            </Grid>
        </Container>
    );

};

export default Reports;
